module.exports = __webpack_public_path__ + "img/market_enable.a03b1a84.svg";